<template>
      <div class="tracks dbox" 
      :v-if="selectedArtistData"
      >
        <v-data-table
          v-if="selectedArtistData.tracks.length > 0"
          :items="selectedArtistData.tracks"
          :headers="headers"
          :hide-headers="false"
          hide-actions
          class="dt-table dbox-table"
        >
         <template slot="headers" slot-scope="props">
          <tr>
             <th
              v-for="header in props.headers"
              :key="header.value"
            >
              {{ header.text }}
            </th>
          </tr>
        </template>
          <template slot="items" slot-scope="props">
            <tr @click="e => onTrackClick(props.item)">
              <td class="booking_artist_trackname" >
                <input type="text" class="dbox-table--textfield"
                  name="booking_artist_trackname"
                  id="booking_artist_trackname"
                  :value="props.item['booking_artist_trackname']"
                  v-on:blur="e => onTrackTextfieldBlur(e, 'booking_artist_trackname', props.item)"
                  >
              </td>
              <td class="reference" >
                <input type="text" class="dbox-table--textfield"
                  name="reference"
                  id="reference"
                  :value="props.item['reference']"
                  v-on:blur="e => onTrackTextfieldBlur(e, 'reference', props.item)"
                  >
              </td>
              <td class="composer" >
                <input type="text" class="dbox-table--textfield"
                  name="composer"
                  id="composer"
                  :value="props.item['composer']"
                  v-on:blur="e => onTrackTextfieldBlur(e, 'composer', props.item)"
                  >
              </td>
              <td class="composer" >
                <input type="text" class="dbox-table--textfield"
                  name="arranger"
                  id="arranger"
                  :value="props.item['arranger']"
                  v-on:blur="e => onTrackTextfieldBlur(e, 'arranger', props.item)"
                  >
              </td>
              <td class="publisher" >
                <input type="text" class="dbox-table--textfield"
                  name="publisher"
                  id="publisher"
                  :value="props.item['publisher']"
                  v-on:blur="e => onTrackTextfieldBlur(e, 'publisher', props.item)"
                  >
              </td>
              <td class="close">
                <div class="close-button">
                  <img
                    src="static/icons/delete.svg" 
                    class="dt-icon" 
                    @click="e => onTrackDelete(props.item)"
                    alt=""
                  >
                </div>
              </td>
            </tr>
          </template>
        </v-data-table>

      <div class="dbox-title-bar--options">
        <div class="button">
          <div class="dt-icon-container">
            <img 
              @click="addTrack" 
              src="static/icons/add.svg" 
              class="dt-icon" 
              alt="">
          </div>
        </div>
      </div> 
    </div>
</template>

<script>
import Dropdown from "@plugins/dropdown/dropdown";

import { bookingListCalendarDateTabRoute } from '../../../router/router';
import { encodeRoute, createMailHref, capitalizeFirst } from '../../../../../utility';

import { isEmpty } from 'ramda';

export default {
  components: {
    Dropdown
  },
  props: {
    selectedArtistData: {
      type: Object,
      required: true
    }
  },
  data: function() {
    return {
      headers: [
        {text: '', value: 'track'},
        {text: 'Reference', value: 'reference'},
        {text: 'Composer', value: 'composer'},
        {text: 'Arranger', value: 'arranger'},
        {text: 'Publisher', value: 'publisher'},
        {text: '', value: 'close'},
      ],
      filter: {
        selectedMonth: null,
        selectedLocation: null,
        selectedCity: null,
        selectedPromoter: null,
        selectedPartner: null
      }
    };
  },
  computed: {
    monthsTV: function() {
      return this.selectedArtistData.months.map(e => ({
        text: `${capitalizeFirst(e.month)} ${e.year}`,
        value: e.month_val
      }));
    },
    locationsTV: function() {
      return this.selectedArtistData.locations.map(e => ({
        text: e.booking_location_name,
        value: e.booking_location_name
      }));
    },
    citiesTV: function() {
      return this.selectedArtistData.cities.map(e => ({
        text: e.city,
        value: e.city
      }));
    },
    promotersTV: function() {
      return this.selectedArtistData.promoters.map((e, i) => ({
        text: e.company_name ? e.company_name : `${e.first_name} ${e.last_name}`,
        value: e.company_name ? e.company_name : `${e.first_name} ${e.last_name}`,
      }));
    },
    partnersTV: function() {
      return this.selectedArtistData.partners.map((e, i) => ({
        text: e.company_name ? e.company_name : `${e.first_name} ${e.last_name}`,
        value: `${i}`
      }));
    },
    filterObject: function() {
      console.log({
        month   : this.filter.selectedMonth,
        location: this.filter.selectedLocation,
        city    : this.filter.selectedCity,
        partner : this.filter.selectedPartner,
        promoter: this.filter.selectedPromoter,
      }, {
        month   : this.filter.selectedMonth    ? this.filter.selectedMonth   .value : '',
        location: this.filter.selectedLocation ? this.filter.selectedLocation.value : '',
        city    : this.filter.selectedCity     ? this.filter.selectedCity    .value : '',
        partner : this.filter.selectedPartner  ? this.filter.selectedPartner .text  : '',
        promoter: this.filter.selectedPromoter ? this.filter.selectedPromoter.text  : ''
      });
      return {
        month   : this.filter.selectedMonth    ? this.filter.selectedMonth   .value : '',
        location: this.filter.selectedLocation ? this.filter.selectedLocation.value : '',
        city    : this.filter.selectedCity     ? this.filter.selectedCity    .value : '',
        partner : this.filter.selectedPartner  ? this.filter.selectedPartner .text  : '',
        promoter: this.filter.selectedPromoter ? this.filter.selectedPromoter.text  : ''
      }
    }
  },
  methods: {
    
    onTrackClick: function(booking) {
      this.$router.push({
        name: bookingListCalendarDateTabRoute, 
        params: {
          calendar_date_id: booking.calendar_date_id, 
          tab: 'overview'
        },
        query: {
          from: encodeRoute(this.$route)
        }
      });
    },
    onMailClick: function(mail) {
      location.href = createMailHref({
        mails: [mail]
      });
    },
    onDropdownChange: function(name, value) {
      console.log(name, value);
      if (isEmpty(value)) {
        value = undefined;
      }
      switch(name) {
        case 'month': {
          this.filter.selectedMonth = value;
          break;
        }
        case 'location': {
          this.filter.selectedLocation = value;
          break;
        }
        case 'city': {
          this.filter.selectedCity = value;
          break;
        }
        case 'partner': {
          this.filter.selectedPartner = value;
          break;
        }
        case 'promoter': {
          this.filter.selectedPromoter = value;
          break;
        }
      }
      this.emitFilter();
    },
    emitFilter: function() {
      this.$emit('filter', this.filterObject);
    },
    
    addTrack: function() {
        this.$emit('addtrack', true);
    },
    onTrackTextfieldBlur: function(event, name, item) {

    },
    onTrackDelete: function(item) {
      console.log(item);
    }


    // MARK: Methods
  }
}

</script>

<style lang="scss" scoped>

.dbox-table {
  --rest-cell-padding: 0px 5px;
  --header-text-align: left;
  --th-padding: 0 7px;

  table {

    th {
      padding: 0 7px;
    }

    th:nth-child(6), 
    td:nth-child(6),
     {
      width: 28px !important;
      max-width: 28px !important;
      padding: 0px 7px !important;
      i {
        font-size: 14px;
      }
    }
  }
}


</style>
